import 'hammerjs';
import 'moment/min/locales';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { LayoutModule } from './layout/layout.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { EnvConfigurationService } from './shared/services/envconf.service';
import { HttpClientModule } from '@angular/common/http';
import { AuthModule } from '@michelin/auth';
import { CustomAuthGuard } from './shared/services/custom-auth.guard';
import { UserService } from './shared/services/user.service';
import { BackendService } from './shared/services/backend';
import { HspModalModule } from "./shared/components/modal/hsp-modal.module";

@NgModule({
  imports: [
    BrowserAnimationsModule,
    LayoutModule,
    AppRoutingModule,
    HttpClientModule,
    AuthModule.forRoot(EnvConfigurationService.getAuthConfigEnv()),
    HspModalModule
],
  declarations: [AppComponent],
  providers: [CustomAuthGuard, UserService, BackendService],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
